<!-- product-list.component.html -->
<h2>Listado de Productos</h2>
<ul>
  <li *ngFor="let product of products">
    <a [routerLink]="['/store/products', product.id]">
      {{ product.name }} - {{ product.price | currency }}
    </a>
  </li>
</ul>
